export default "/assets/images/bbq-video.mp4?65ff5af8d9f14f13cada3ea9c257c107";